if (!customElements.get('nosto-slider')) {
  class NostoSlider extends HTMLElement {
    constructor() {
      super();
      this.intervalLimit = 20;
      this.sectionId = '';
      this.hasCustomControls = false;
      this.interval = null;
    }

    connectedCallback() {
      const nostoParent = this.closest('.nosto_element');
      this.sectionId = nostoParent?.getAttribute('data-section-id');

      const arrows = this.getArrowElements();
      this.hasCustomControls = Boolean(arrows.prev && arrows.next);

      if (!arrows.useTabHeader) {
        const controlsTemplate = document.getElementById(
          `nosto-placement-slider-controls--${this.sectionId}`
        );

        if (controlsTemplate) {
          const controls = controlsTemplate.content.cloneNode(true);
          nostoParent.querySelector('.nosto-placement__header')?.appendChild(controls);
        }
      }

      this.startInitPolling();
    }

    disconnectedCallback() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    getArrowElements() {
      const tabsRoot = this.closest('nosto-placement-tabs');
      const tabControls = tabsRoot?.querySelector('.nosto-placement-tabs__controls');

      if (tabControls) {
        return {
          prev: tabControls.querySelector('.controls__arrow__prev'),
          next: tabControls.querySelector('.controls__arrow__next'),
          useTabHeader: true,
        };
      }

      const panelRoot = document.getElementById(this.sectionId);

      return {
        prev: panelRoot?.querySelector('.controls__arrow__prev') ?? null,
        next: panelRoot?.querySelector('.controls__arrow__next') ?? null,
        useTabHeader: false,
      };
    }

    isPlacementVisible() {
      const panel = this.closest('[role="tabpanel"]');
      if (!panel) return true;
      return !panel.hasAttribute('hidden');
    }

    hasSliderContent() {
      return this.querySelector('nosto-card') !== null;
    }

    startInitPolling() {
      this.interval = window.setInterval(() => {
        this.intervalLimit = this.intervalLimit - 1;

        if (this.intervalLimit <= 0) {
          window.clearInterval(this.interval);
          this.interval = null;
          return;
        }

        if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;

        if (!this.isPlacementVisible()) return;

        if (!this.hasSliderContent()) return;

        const $slider = window.jQuery(this);
        if ($slider.hasClass('slick-initialized')) {
          window.clearInterval(this.interval);
          this.interval = null;
          return;
        }

        this.initSlider();
        window.clearInterval(this.interval);
        this.interval = null;
      }, 500);
    }

    initSlider() {
      if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;

      const $slider = window.jQuery(this);
      if ($slider.hasClass('slick-initialized')) return;

      if (!this.isPlacementVisible()) return;

      const arrows = this.getArrowElements();
      const hasArrows = Boolean(arrows.prev && arrows.next);

      this.style.display = 'flex';

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: hasArrows,
        prevArrow: hasArrows ? window.jQuery(arrows.prev) : undefined,
        nextArrow: hasArrows ? window.jQuery(arrows.next) : undefined,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false,
            },
          },
        ],
      });
    }

    ensureInitialized() {
      if (!this.isPlacementVisible()) return;

      if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;

      const $slider = window.jQuery(this);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
        return;
      }

      if (!this.hasSliderContent()) return;

      this.initSlider();
    }

    refreshSlider() {
      if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;

      const $slider = window.jQuery(this);
      if (!$slider.hasClass('slick-initialized')) return;

      $slider.slick('setPosition');
      $slider.slick('refresh');
    }
  }

  customElements.define('nosto-slider', NostoSlider);
}

if (!customElements.get('nosto-card')) {
  class NostoCard extends HTMLElement {
    constructor() {
      super();
      this.sectionId = '';
    }

    connectedCallback() {
      const nostoParent = this.closest('.nosto_element');
      this.sectionId = nostoParent?.getAttribute('data-section-id');

      if (this.querySelector('.card-wrapper')) return;

      const productHandle = this.getAttribute('data-product-handle');

      if (productHandle) {
        fetch(`/products/${productHandle}?view=nosto-card&sectionId=${this.sectionId}`)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cardContent = doc.querySelector('.card-wrapper');

            while (this.firstChild) {
              this.removeChild(this.firstChild);
            }

            if (cardContent) {
              const isFirstCard =
                this.hasAttribute('data-first-card') ||
                this.parentNode?.querySelectorAll('nosto-card:not(:empty)').length === 0;
              if (isFirstCard) {
                const styleTags = doc.querySelectorAll('link[rel="stylesheet"]');
                styleTags.forEach((styleTag) => {
                  this.appendChild(styleTag.cloneNode(true));
                });
              }
              this.appendChild(cardContent.cloneNode(true));

              this.refreshSwym();

              const cardElement = this.querySelector('.card');
              cardElement?.addEventListener('swym:refresh', () => {
                this.refreshSwym();
              });
            } else {
              this.remove();
            }
          })
          .catch((error) => {
            console.error('Error fetching product card:', error);
            this.remove();
          });
      }
    }

    refreshSwym() {
      if (window._swat) {
        window._swat.initializeActionButtons(`#${this.sectionId}`);
      }
    }
  }

  customElements.define('nosto-card', NostoCard);
}
